import { API_ROUTES, HTTP_METHODS, PAGE_SIZE } from '@Utils/constants';
import { sendCall } from '@Utils/request.utils';

const { ACCESSORIES } = API_ROUTES;

class AccessoriesServices {
  createAccessory = (params: unknown) =>
    sendCall(ACCESSORIES.POST, {
      data: params,
      method: HTTP_METHODS.POST,
    });

  getAccessories = (page: number | null, pagination: boolean) =>
    sendCall(`${ACCESSORIES.GET}?page=${page}&limit=${PAGE_SIZE}&pagination=${pagination}`, {
      method: HTTP_METHODS.GET,
    });

  getAccessory = (id: string | undefined) => sendCall(`${ACCESSORIES.GET}/${id}`, { method: HTTP_METHODS.GET });

  updateAccessory = (id: string | undefined, params: unknown) =>
    sendCall(`${ACCESSORIES.PUT}/${id}`, {
      data: params,
      method: HTTP_METHODS.PUT,
    });

  disableAccessory = (id: string | undefined) =>
    sendCall(`${ACCESSORIES.DISABLE}/${id}`, {
      method: HTTP_METHODS.POST,
    });

  searchAccessories = (params: unknown, page: number) =>
    sendCall(`${ACCESSORIES.SEARCH_POST}?page=${page}&limit=${PAGE_SIZE}`, {
      data: params,
      method: HTTP_METHODS.POST,
    });

  assignAccessory = (id: string | undefined, params: unknown) =>
    sendCall(`${ACCESSORIES.ASSIGN}/${id}`, {
      data: params,
      method: HTTP_METHODS.PUT,
    });

  unassignAccessory = (id: string | undefined, params: unknown) =>
    sendCall(`${ACCESSORIES.UNASSIGN}/${id}`, {
      data: params,
      method: HTTP_METHODS.PUT,
    });
}

export default new AccessoriesServices();
